//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import React from 'react';
import styled from 'styled-components';

import { PrimaryAnchor } from '@components/atoms/anchor/Anchor';
import Icon from '@components/atoms/icon/Icon';
import { BodyBoldText, BodyText } from '@components/atoms/text/Text';
import { UiaProductTrackingIds } from '@uia/products/constants/UiaProductConstants';

export const UrlNotFoundWarning = () => {
  return (
    <WarningContainer>
      <Icon name='alarm' />
      <WarningContent>
        <BodyBoldText>We couldn't find this URL in your catalog.</BodyBoldText>
        <BodyText>
          You may choose to tag anyway as a URL. Consumers will still be able to
          click on the tag in your touchpoints, but we are unable to surface
          this media on your Galleries PDP, or to provide product
          recommendations in Showroom.
        </BodyText>
        <PrimaryAnchor
          href='https://support.bazaarvoice.com/s/article/Productizing-Content'
          target='_blank'
          trackingId={UiaProductTrackingIds.PRODUCT_EDITOR_LEARN_MORE_LINK}
        >
          Visit our FAQs to learn more.
        </PrimaryAnchor>
      </WarningContent>
    </WarningContainer>
  );
};

const WarningContainer = styled.div(
  ({ theme }) => `
    display: flex;
    flex-direction: row;
    gap: ${theme.spacings[2]};
  `,
);

const WarningContent = styled.div(
  ({ theme }) => `
    display: flex;
    flex-direction: column;
    gap: ${theme.spacings[2]};
  `,
);
